import React from "react";
import { Plus, Trash, CreditCard } from "@phosphor-icons/react";

const inp = "w-full h-9 px-2 border border-border-control bg-white text-[13.5px] rounded-[8px] focus:border-ink-primary focus:ring-2 focus:ring-equipr-yellow/40 focus:outline-none";
const lbl = "text-[10.5px] font-bold uppercase tracking-[0.1em] text-ink-muted mb-1.5 block";
const CATS = ["Fuel", "Service", "Rego", "Insurance", "Tolls", "Other"];

export default function VehicleCostsTab({ form, setForm }) {
  const costs = form.costs || [];
  const setRow = (i, k, v) => setForm((s) => { const arr = [...(s.costs || [])]; arr[i] = { ...arr[i], [k]: v }; return { ...s, costs: arr }; });
  const add = () => setForm((s) => ({ ...s, costs: [...(s.costs || []), { date: "", category: "Fuel", amount: "", note: "" }] }));
  const del = (i) => setForm((s) => ({ ...s, costs: (s.costs || []).filter((_, j) => j !== i) }));
  const total = costs.reduce((t, c) => t + (Number(c.amount) || 0), 0);

  return (
    <div className="space-y-4" data-testid="vehicle-costs-tab">
      <div>
        <label className={lbl}>Fuel Card #</label>
        <input className={inp + " max-w-xs"} value={form.fuel_card || ""} onChange={(e) => setForm((s) => ({ ...s, fuel_card: e.target.value }))} data-testid="vehicle-fuel-card" placeholder="e.g. FC-9001" />
      </div>
      <div className="flex items-center justify-between">
        <h4 className="text-[13px] font-bold text-equipr-black inline-flex items-center gap-1.5"><CreditCard size={16} /> Running Costs</h4>
        <button onClick={add} data-testid="vehicle-cost-add" className="text-xs font-semibold text-equipr-black inline-flex items-center gap-1 hover:underline"><Plus size={13} /> Add cost</button>
      </div>
      {costs.length === 0 ? <p className="text-xs text-gray-400">No costs recorded.</p> : (
        <table className="w-full text-[12px]">
          <thead><tr className="text-left text-gray-500 border-b border-gray-200">{["Date", "Category", "Amount", "Note", ""].map((h) => <th key={h} className="px-2 py-1.5 font-semibold">{h}</th>)}</tr></thead>
          <tbody>
            {costs.map((c, i) => (
              <tr key={i} className="border-b border-gray-50" data-testid={`vehicle-cost-row-${i}`}>
                <td className="px-1.5 py-1"><input type="date" className={inp} value={c.date || ""} onChange={(e) => setRow(i, "date", e.target.value)} /></td>
                <td className="px-1.5 py-1"><select className={inp} value={c.category || "Fuel"} onChange={(e) => setRow(i, "category", e.target.value)}>{CATS.map((x) => <option key={x}>{x}</option>)}</select></td>
                <td className="px-1.5 py-1"><input type="number" step="0.01" className={inp} value={c.amount ?? ""} onChange={(e) => setRow(i, "amount", e.target.value === "" ? "" : Number(e.target.value))} /></td>
                <td className="px-1.5 py-1"><input className={inp} value={c.note || ""} onChange={(e) => setRow(i, "note", e.target.value)} /></td>
                <td className="px-1.5 py-1 text-right"><button onClick={() => del(i)} className="text-gray-400 hover:text-red-600"><Trash size={14} /></button></td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr className="bg-equipr-yellow/20"><td colSpan={2} className="px-2 py-1.5 text-right font-bold text-equipr-black">Total</td><td className="px-2 py-1.5 font-bold text-equipr-black" data-testid="vehicle-cost-total">${total.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td><td colSpan={2} /></tr></tfoot>
        </table>
      )}
    </div>
  );
}
